export function getAppBaseUrl(){
    if(process.env.VUE_APP_PUBLIC_DOMAIN){
        let port = 80
        const protocol = window.location.protocol
        if (window.location.port !== 80 && window.location.port !== 443)
            port = `:${window.location.port}`
      return `${protocol}//${process.env.VUE_APP_PUBLIC_DOMAIN}${port}/`
    }else{
        return window.location.origin
    }

}

export function getGraphqlPublicUrl(){
    if(process.env.VUE_APP_GRAPHQL_PUBLIC_ENDPOINT){
        return `${getApiServerBaseUrl()}${process.env.VUE_APP_GRAPHQL_PUBLIC_ENDPOINT}`
    }else{
        return `${window.location.origin}${process.env.VUE_APP_GRAPHQL_PUBLIC_ENDPOINT}`
    }

}

export function getGraphqlWsPublicUrl(){
    if(process.env.VUE_APP_GRAPHQL_WS_PUBLIC_ENDPOINT){
        return `${getApiServerBaseUrl()}${process.env.VUE_APP_GRAPHQL_WS_PUBLIC_ENDPOINT}`
    }else{
        return `${window.location.origin}${process.env.VUE_APP_GRAPHQL_WS_PUBLIC_ENDPOINT}`
    }

}


export function getGraphqlPrivateUrl(){
    if(process.env.VUE_APP_GRAPHQL_PRIVATE_ENDPOINT){
        return `${getApiServerBaseUrl()}${process.env.VUE_APP_GRAPHQL_PRIVATE_ENDPOINT}`
    }else{
        return `${window.location.origin}${process.env.VUE_APP_GRAPHQL_PRIVATE_ENDPOINT}`
    }

}

export function getGraphqlWsPrivateUrl(){
    if(process.env.VUE_APP_GRAPHQL_WS_PRIVATE_ENDPOINT){
        return `${getApiServerBaseUrl()}${process.env.VUE_APP_GRAPHQL_WS_PRIVATE_ENDPOINT}`
    }else{
        return `${window.location.origin}${process.env.VUE_APP_GRAPHQL_WS_PRIVATE_ENDPOINT}`
    }

}

export function getApiServerBaseUrl(){
    if(process.env.VUE_APP_API_APP_BASE_URL){
        return process.env.VUE_APP_API_APP_BASE_URL
    }else{
        return window.location.origin
    }
}


export function getCustomerBackgoundUrl(){
    return `${getApiServerBaseUrl()}${process.env.VUE_APP_URL_SCREEN_BACKGROUND_LOGIN}`
}


export function getCustomerLogoUrl(){
    return `${getApiServerBaseUrl()}${process.env.VUE_APP_URL_LOGO_LOGIN || "/pwa/public/customer/logo"}`
}


export function getBayTypeIconUrl(bayId){
    const defaultUrl = `/pwa/public/bay_types/${bayId}/icon`
    let env_url = null
    if(process.env.VUE_APP_URL_BAYTYPE_ICON){
        env_url = process.env.VUE_APP_URL_BAYTYPE_ICON.replace(":id",bayId)
    }
    return `${getApiServerBaseUrl()}${env_url || defaultUrl}`
}

export function getAppCustomerSelectionUrl(){

    return process.env.VUE_APP_NO_CUSTOMER_PUBLIC_URL

}